import { render, staticRenderFns } from "./integral-rule.vue?vue&type=template&id=95676842&scoped=true&"
import script from "./integral-rule.vue?vue&type=script&lang=js&"
export * from "./integral-rule.vue?vue&type=script&lang=js&"
import style0 from "./integral-rule.vue?vue&type=style&index=0&id=95676842&prod&lang=scss&"
import style1 from "./integral-rule.vue?vue&type=style&index=1&id=95676842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95676842",
  null
  
)

export default component.exports